module.exports = __webpack_public_path__ + "img/img_default01.98277acc.png";